import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "availableState", "expiredState", "countdown", "submitButton" ]
  static values = {
    countdownTemplate: String,
    expiredText: String,
    expiresAt: String
  }

  connect() {
    if (!this.requiredTargetsPresent()) {
      console.warn("[upsell-offer] missing required targets")
      return
    }

    this.tick()
    this.timer = window.setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.timer) {
      window.clearInterval(this.timer)
    }
  }

  tick() {
    const expiresAt = new Date(this.expiresAtValue)
    const expiresAtMs = expiresAt.getTime()

    if (Number.isNaN(expiresAtMs)) {
      this.expireOffer()
      return
    }

    const remainingMs = expiresAtMs - Date.now()

    if (remainingMs <= 0) {
      this.expireOffer()
      return
    }

    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = this.countdownTemplateValue.replace("%{time}", this.formatDuration(remainingMs))
    }
  }

  expireOffer() {
    if (this.timer) {
      window.clearInterval(this.timer)
      this.timer = null
    }

    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = this.expiredTextValue
    }

    if (this.hasAvailableStateTarget) {
      this.availableStateTarget.classList.add("hidden")
    }

    if (this.hasExpiredStateTarget) {
      this.expiredStateTarget.classList.remove("hidden")
    }

    this.submitButtonTargets.forEach((button) => {
      button.disabled = true
      button.setAttribute("aria-disabled", "true")
    })
  }

  requiredTargetsPresent() {
    return this.hasCountdownTarget && this.hasAvailableStateTarget && this.hasExpiredStateTarget
  }

  formatDuration(remainingMs) {
    const totalSeconds = Math.max(Math.floor(remainingMs / 1000), 0)
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60

    if (hours > 0) {
      return `${hours}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
    }

    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
  }
}
